import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/assets/pictos/z-0/building.png");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Breadcrumb/sk-Breadcrumb.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Badge/sk-Badge.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardContainer/sk-CardContainer.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/sk-Card.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBody/sk-CardBody.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBodyContent/sk-CardBodyContent.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBodyHeader/sk-CardBodyHeader.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardCover/sk-CardCover.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardCoverImage/sk-CardCoverImage.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardFooter/sk-CardFooter.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Signature/sk-Signature.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/IconButton/sk-IconButton.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Callout/sk-Callout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/circleci/project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Body/Description.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["RegistrationFormProvider"] */ "/home/circleci/project/src/features/eventDetails/components/Context/RegistrationFormContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Edition"] */ "/home/circleci/project/src/features/eventDetails/components/Edition/Edition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractivePageContent"] */ "/home/circleci/project/src/features/eventDetails/components/Layout/InteractivePageContent.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/MainDetails/EventDates.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainButtonBlockUnlogged"] */ "/home/circleci/project/src/features/eventDetails/components/RegistrationDetails/MainButtonBlockUnlogged.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegistrationDetails"] */ "/home/circleci/project/src/features/eventDetails/components/RegistrationDetails/RegistrationDetails.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/careerCenter/components/SchoolBadge/SchoolBadge.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/company/components/CompanyCard/CompanyCard.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Body/Body.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Body/Companies.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Divider/Divider.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Layout/Layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Header/Header.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/MainDetails/Companies.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/MainDetails/MainDetails.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/eventDetails/components/Layout/Breadcrumb.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FollowButton"] */ "/home/circleci/project/src/modules/company/components/CompanyCard/FollowButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/home/circleci/project/src/modules/i18n/components/TranslationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProviderWrapper"] */ "/home/circleci/project/src/modules/queryClient/components/QueryClientProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppTrackingPageViewPropsUpdater"] */ "/home/circleci/project/src/modules/tracking/components/AppTrackingPageViewPropsUpdater.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/tracking/components/TrackLink.tsx");
